<div class="text-editor__toolbar-container" [class.visible]="focused" (mousedown)="$event.preventDefault()">
  @if (settings.usePipe) {
    <button
      #tooltipRef="matTooltip"
      mat-icon-button
      aria-label="Pipe"
      matTooltip="Pipe"
      (click)="onSelectPipe()"
      (mouseenter)="tooltipRef.show();"
      (mouseleave)="tooltipRef.hide();"
    >
      <fa-icon [icon]="faCode"></fa-icon>
    </button>
    <mat-divider [vertical]="true"></mat-divider>
  }
  <div class="text-editor__toolbar" [ngClass]="'text-editor__toolbar_' + id"></div>
</div>

<div class="text-editor__container" [class.hasMedia]="hasMedia" [class.focused]="focused">
  <div class="text-editor__input-prefix">
    <ng-content select="[slot=prefix]"></ng-content>
  </div>
  <ckeditor [id]="'ckeditor' + id" [editor]="editor" [formControl]="editorCtrl" [ngClass]="settings.appearance" (ready)="onReady($event)"></ckeditor>
  <ng-content select="[slot=suffix]"></ng-content>
</div>
